import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SourceForm } from '@/features/sources/components/SourceForm/SourceForm';
import { useCreateSource } from '@/features/sources/hooks/useCreateSource';
import type { SourceFormData } from '@/features/sources/types/source.types';

export const Route = createFileRoute('/_auth/sources/create')({
  component: CreateSourcePage,
});

function CreateSourcePage() {
  const navigate = useNavigate();
  const createMutation = useCreateSource();

  const handleSubmit = (data: SourceFormData) => {
    createMutation.mutate(data, {
      onSuccess: () => {
        navigate({ to: '/sources' });
      },
    });
  };

  const handleCancel = () => {
    navigate({ to: '/sources' });
  };

  return (
     <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
          <SourceForm onSubmit={handleSubmit} onCancel={handleCancel} isSubmitting={createMutation.isPending} />   
      </div>
    </div>
  );
}
